export default "__VITE_ASSET__C5yLf_WR__"